import { TypedDocumentNode, gql } from '@apollo/client';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { SimpleSelect } from '@sorare/core/src/components/form/Form/SimpleSelect';

import { DivisionIcon } from 'components/rivals/seasons/divisionPicker/DivisionIcon';

import { DropdownDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig } from './__generated__/index.graphql';

type Props = {
  divisionConfigs: DropdownDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig[];
  onSelectDivision: (
    division: DropdownDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig
  ) => void;
  selectedDivision: DropdownDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig;
};

export const DropdownDivisionPicker = ({
  divisionConfigs,
  onSelectDivision,
  selectedDivision,
}: Props) => {
  const options = divisionConfigs.map(({ id, title, badgeUrl }) => ({
    label: (
      <Horizontal key={id} gap={1}>
        <DivisionIcon
          badgeUrl={badgeUrl}
          title={title}
          width={24}
          selected={selectedDivision.id === id}
        />
        <LabelL as="span">{title}</LabelL>
      </Horizontal>
    ),
    value: id,
  }));

  return (
    <SimpleSelect
      options={options}
      value={selectedDivision.id}
      name="SeasonDivisions"
      onChange={event => {
        const id = (event.target as HTMLInputElement).value;
        const division = divisionConfigs.find(d => d.id === id);
        if (division) {
          onSelectDivision(division);
        }
      }}
    />
  );
};

DropdownDivisionPicker.fragments = {
  footballRivalsDivisionLeaderboardDivisionConfig: gql`
    fragment DropdownDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig on FootballRivalsDivisionLeaderboardDivisionConfig {
      id
      badgeUrl
      title
    }
  ` as TypedDocumentNode<DropdownDivisionPicker_footballRivalsDivisionLeaderboardDivisionConfig>,
};
